<h3>{{ 'WELCOME' | translate }} {{ (currentUser$ | async)?.fullName }}</h3>
<!-- Application Maintainence Message -->
<!-- <h4 style="color: rgb(155, 4, 4); margin-bottom: 20px; padding-bottom: 20px;" >
    {{  
    'Migration.Maintenance'
    | translate 
    }}  
    </h4> -->